import { AdminPagePath, renderVseView } from "@ancademy/vse-client";
import { adjustRem, Color } from "@client";
import { injectGlobal } from "@emotion/css";
import { Npc } from "@npc";
import { subViewList } from "@sub";
import { ConfigProvider } from "antd";
import { wrapStatisticsPage } from "./Admin/Statistics";
import "./global.css";
import { mainView } from "./Main/view";

ConfigProvider.config({
  theme: {
    primaryColor: Color.main,
  },
});

window.addEventListener("resize", adjustRem());

injectGlobal`
  @keyframes antFadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  *::-webkit-scrollbar {
    width: 0.8rem;
  }

  *::-webkit-scrollbar-track {
    background-color: ${Color.light};
    border-radius: 0.4rem;
  }

  *::-webkit-scrollbar-thumb {
    background-color: ${Color.main};
    border-radius: 0.4rem;
  }

  .ant-form-item-row {
    align-items: center;
  }

  .ant-modal-confirm-title {
    font-size: 2.2rem !important;
    color: ${Color.main} !important;
  }
`;

Npc.init();
renderVseView({
  mainView,
  subViewList,
  customAdminPages: (pages) =>
    pages.map((page) => (page.path === AdminPagePath.Statistics ? wrapStatisticsPage(page) : page)),
});
